import { z } from "zod";

export const profileCompletionSchema = z.object({
  phoneNumber: z
    .string()
    .min(1, "מספר טלפון שדה חובה")
    .regex(/^[\d\s\-+()]+$/, "מספר טלפון לא תקין"),
  businessName: z
    .string()
    .min(1, "שם עסק שדה חובה")
    .min(2, "שם עסק חייב להכיל לפחות 2 תווים"),
  // Optional — empty string is allowed; profile can complete without it.
  businessNumber: z.string().trim(),
  city: z
    .string()
    .min(1, "עיר שדה חובה")
    .min(2, "שם העיר חייב להכיל לפחות 2 תווים"),
});

export type ProfileCompletionFormValues = z.infer<typeof profileCompletionSchema>;
